import React, { useEffect } from 'react';
import CompMarquee from '../Components/CompMarquee';
import CompContentBlock from '../Components/CompContentBlock';
import { Grid } from '@mui/material';
import UXImgContactFeature1 from '../Assets/Images/uxi-2025-contact-feature1.png';

function Contact() {
  useEffect(() => {
    if (!document.getElementById('hubspot-script')) {
      const script = document.createElement('script');
      script.id = 'hubspot-script';
      script.src = '//js.hsforms.net/forms/embed/v2.js';
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.onload = () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: '44366894',
            formId: '60c07592-b1bb-4c57-be55-16e3f3f03d94',
            region: 'na1',
            target: '#hubspot-form',
          });
        }
      };
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div>
      <CompMarquee title="Contact Us" subTitle="Let's Talk" />
      <CompContentBlock heading="Get in Touch" subheading="We'd love to hear from you.">
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <img src={UXImgContactFeature1} alt="Contact Us" style={{ width: '100%', border: '1px solid #f1f1f1' }} />
            <h5 style={{ marginTop: '10px' }}>Reach Out to Us</h5>
            <p>
              Whether you have questions about our services, need support, or just want to say hello, we're here to help.
            </p>
          </Grid>
          <Grid item xs={12} md={6}>
            <div style={{ background: '#ffffff', padding: '20px', width: '100%' }}>
              <div id="hubspot-form" style={{ width: '100%' }}></div>
            </div>
          </Grid>
        </Grid>
      </CompContentBlock>
    </div>
  );
}

export default Contact;
